export const OrderServicesLabel = "Services";
